import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Button } from "@mui/material";
import { deleteAllSubLeagues, getNcaafSubLeagues, getTeamsByConference, uploadNcaafSubLeaguesExcel } from "../../API/LeagueAPI/LeaguesApi";

const PRIMARY_COLOR = "#EF4B4B";

const styles = {
  pageTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 4,
    color: "#222",
  },
  panelTitle: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 10,
    color: "#222",
  },
  subdivisionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: "#888",
    marginTop: 4,
    letterSpacing: "0.5px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  deleteButton: {
    backgroundColor: PRIMARY_COLOR,
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },

};


function NCAAFSubLeagues() {
  const [ncaafLeagues, setNcaafLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedConference, setSelectedConference] = useState(null);
  const [teams,setTeams] = useState([]);

  // 🔹 Upload states
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const userToken = sessionStorage.getItem("token");

  useEffect(() => {
    if (!userToken) return;

    setLoading(true);

    getNcaafSubLeagues(userToken)
      .then((res) => {
        if (res?.data) setNcaafLeagues(res.data);
      })
      .catch((err) => console.log(err?.response || err))
      .finally(() => setLoading(false));
  }, []);

  // 🟢 File selection
  const handleFileChange = (e) => {
    const selected = e.target.files[0];

    if (!selected) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!allowedTypes.includes(selected.type)) {
      alert("Only Excel files (.xlsx, .xls) are allowed");
      return;
    }

    setFile(selected);
  };


  const handleConferenceClick = (conference,subDivision) => {
    console.log(conference)
    setSelectedConference(conference);
  
    getTeamsByConference(userToken, conference,subDivision)
      .then((res) => {
        setTeams(res.data.teams);
      })
      .catch(console.error);
  };

  const handleDeleteAll = async () => {
    const confirmDelete = window.confirm(
      "⚠️ This will permanently delete ALL sub-leagues. Continue?"
    );
  
    if (!confirmDelete) return;
  
    try {
      deleteAllSubLeagues(userToken).then((res)=>{
        console.log(res?.data);
        alert(res?.data.message || "Deleted successfully");
        getNcaafSubLeagues(userToken).then((res)=>{
          setNcaafLeagues(res.data);
        })
        setTeams([]);
      }).catch((err)=>{
        console.log(err);
      })
    } catch (error) {
      console.error("Delete error:", error);
      alert("Failed to delete collection");
    }
  };

  // 🚀 Upload file
  const handleUpload = async () => {
    if (!file) {
      alert("Please select an Excel file first");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", file);

      await uploadNcaafSubLeaguesExcel(file, userToken);

      alert("Upload successful");

      // 🔄 Refresh data
      const res = await getNcaafSubLeagues(userToken);
      if (res?.data) setNcaafLeagues(res.data);

      setFile(null);
    } catch (err) {
      console.log(err?.response || err);
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: "10px" }}>
    <div style={styles.headerRow}>
  <div style={styles.pageTitle}>
    NCAAF Sub-Leagues Configuration
  </div>

  <button
    style={styles.deleteButton}
    onClick={handleDeleteAll}
  >
    Delete All Sub-Leagues
  </button>
</div>
  
     {/* ================= UPLOAD SECTION ================= */}
<Box
  sx={{
    mb: 2,
    p: 2,
    border: "1px dashed #d0d5dd",
    borderRadius: "8px",
    background: "#fafbfd",
    fontSize: "13px",
  }}
>
  {/* Title */}
  <Box sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#333" }}>
    Upload Conference Excel
  </Box>

  {/* File Input */}
  <input
    type="file"
    accept=".xlsx,.xls"
    onChange={handleFileChange}
    style={{
      fontSize: "12px",
      padding: "4px 0",
    }}
  />

  {/* Selected File Name */}
  {file && (
    <Box
      sx={{
        mt: 1,
        fontSize: "12px",
        color: "#555",
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: "6px",
        px: 1,
        py: 0.5,
        display: "inline-block",
      }}
    >
      {file.name}
    </Box>
  )}

  {/* Upload Button */}
  <Box mt={1.5}>
    <Button
      variant="contained"
      size="small"
      onClick={handleUpload}
      disabled={!file || uploading}
      sx={{
        fontSize: "12px",
        px: 2,
        py: 0.6,
        backgroundColor: "#EF4B4B",
        "&:hover": { backgroundColor: "#d93c3c" },
        textTransform: "none",
        borderRadius: "6px",
      }}
    >
      {uploading ? "Uploading..." : "Upload File"}
    </Button>
  </Box>
</Box>

  
      {/* ================= MAIN SPLIT PANEL ================= */}
  
      {loading ? (
        <Box display="flex" justifyContent="center" sx={{ mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <div style={{ display: "flex", gap: "20px" }}>
  
          {/* 🔹 LEFT PANEL — Conferences */}
          <div
            style={{
              width: "30%",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "12px",
              height: "70vh",
              overflowY: "auto",
            }}
          >
            <div style={styles.panelTitle}>
              Conferences
            </div>
  
            {ncaafLeagues.map((section) => (
              <div key={section.subdivision}>
              <div style={styles.subdivisionTitle}>
                {section.subdivision}
              </div>

  
              {section.keys.map((key) => {
                const isSelected = selectedConference === key;

                return (
                  <div
                    key={key}
                    onClick={() =>
                      handleConferenceClick(key, section.subdivision)
                    }
                    style={{
                      padding: "7px 10px",
                      marginTop: 6,
                      borderRadius: 6,
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 500,
                      transition: "all 0.15s ease",
                      backgroundColor: isSelected ? "#FDECEC" : "#FAFAFA",
                      color: isSelected ? "#EF4B4B" : "#333",
                      border: isSelected
                        ? "1px solid #EF4B4B"
                        : "1px solid #EEE",
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected)
                        e.currentTarget.style.backgroundColor = "#F7F7F7";
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected)
                        e.currentTarget.style.backgroundColor = "#FAFAFA";
                    }}
                  >
                    {key}
                  </div>
                );
              })}

              </div>
            ))}
          </div>
  
          {/* 🔹 RIGHT PANEL — Teams */}
          <div
            style={{
              width: "70%",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "16px",
              height: "70vh",
              overflowY: "auto",
            }}
          >
            <div style={{ padding: 12 }}>
  <h6
    style={{
      marginBottom: 12,
      fontSize: 14,
      fontWeight: 600,
      color: "#333",
    }}
  >
    Teams in {selectedConference}
  </h6>

  {teams.length === 0 ? (
    <p style={{ fontSize: 13, color: "#888" }}>
      No teams available
    </p>
  ) : (
    teams.map((team) => (
      <div
        key={team.key}
        style={{
          padding: "10px 12px",
          marginBottom: 10,
          borderRadius: 8,
          border: "1px solid #EAEAEA",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        }}
      >
        {/* Team Name + Key */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 6,
          }}
        >
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#222",
            }}
          >
            <b>Team Name:</b>{team.teamName}
          </span>

            <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
              borderRadius: 12,
              background: "#FDECEC",
              color: "#EF4B4B",
            }}
          >
           <b>Key : </b> {team.key}
          </span>
        </div>

        {/* School */}
        <div
          style={{
            fontSize: 12,
            color: "#555",
            marginBottom: 4,
          }}
        >
          <b>School:</b> {team.schoolName}
        </div>

        {/* Mascot */}
        <div
          style={{
            fontSize: 12,
            color: "#555",
          }}
        >
          <b>Mascot:</b> {team.mascot || "—"}
        </div>
      </div>
    ))
  )}
</div>

          </div>
        </div>
      )}
    </div>
  );
  
}

export default NCAAFSubLeagues;
